try {
  require('dotenv').config();
} catch (e) {}

if (
  !process.env.__ANGULAR_CONSOLE__NRWL_API ||
  process.env.__ANGULAR_CONSOLE__NRWL_DEV !== 'true'
) {
  process.env.__ANGULAR_CONSOLE__NRWL_API = 'https://api.nrwl.io';
}

if (
  !process.env.__ANGULAR_CONSOLE__CONNECT_URL ||
  process.env.__ANGULAR_CONSOLE__NRWL_DEV !== 'true'
) {
  process.env.__ANGULAR_CONSOLE__CONNECT_URL = 'https://connect.nrwl.io';
}

if (
  !process.env.__ANGULAR_CONSOLE__AUTH0_CLIENT_ID ||
  process.env.__ANGULAR_CONSOLE__NRWL_DEV !== 'true'
) {
  process.env.__ANGULAR_CONSOLE__AUTH0_CLIENT_ID =
    'fg2a50wlJtHzTaJIxfFVw8p36QpoZBgG';
}

if (
  !process.env.__ANGULAR_CONSOLE__AUTH0_DOMAIN ||
  process.env.__ANGULAR_CONSOLE__NRWL_DEV !== 'true'
) {
  process.env.__ANGULAR_CONSOLE__AUTH0_DOMAIN = 'auth.nrwl.io';
}

if (
  !process.env.__ANGULAR_CONSOLE__AUTH0_AUDIENCE ||
  process.env.__ANGULAR_CONSOLE__NRWL_DEV !== 'true'
) {
  process.env.__ANGULAR_CONSOLE__AUTH0_AUDIENCE = 'https://api.nrwl.io/';
}

export const CONNECT_URL = `${process.env.__ANGULAR_CONSOLE__CONNECT_URL}`;
export const GRAPHQL_ENDPOINT = `${process.env.__ANGULAR_CONSOLE__NRWL_API}`;
export const AUTH0_CLIENT_ID = process.env.__ANGULAR_CONSOLE__AUTH0_CLIENT_ID;
export const AUTH0_DOMAIN = process.env.__ANGULAR_CONSOLE__AUTH0_DOMAIN;
export const AUTH0_AUDIENCE = process.env.__ANGULAR_CONSOLE__AUTH0_AUDIENCE;
